'use client';
import styles from './card.module.css';
import Link from 'next/link';
import { ToolTip } from '@/components/tooltip/tooltip';
import ActionButton from '@/components/action-button/action-button';
import { WebsiteTrial as Trial } from '@/types/trial';
import { getStudyStatus, merge } from '@scitrials-sst/core/Next/lib';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import MyMarkdown from '@/components/my-markdown/my-markdown';

export default function Card({
	sponsored = false,
	trial,
}: {
	sponsored?: boolean;
	trial?: Trial;
}) {
	if (!trial) return null;
	const status = getStudyStatus(trial?.overallStatus ?? '');
	const isGreen =
		['Recruiting', 'Enrolling by invitation'].includes(status.title) ?? false;

	const tags = merge(trial?.treatments ?? [], trial?.outcomes ?? []);

	return (
		<div
			className={styles.card}
			style={{ background: `${sponsored && 'lightyellow'}` }}
		>
			{sponsored && (
				<div className={styles.sponsored}>
					<h3>Sponsored Trials</h3>
				</div>
			)}
			<div className={styles['title-tag']}>
				<Link href={`/trial/${trial?.objectID}`}>
					<div className={styles.title}>
						<h2>{trial?.title}</h2>
					</div>
				</Link>

				<h3
					className={styles.status}
					style={{
						color: isGreen ? '#008000' : '#606060',
						textAlign: 'end',
					}}
				>
					{status.title}
				</h3>
			</div>
			<div className={styles.desc}>
				<MyMarkdown text={trial?.desc ?? ''} truncate />
			</div>

			{trial?.distance ? (
				<h3>Closest location is {trial?.distance} km away</h3>
			) : null}

			<div className={styles['card-footer']}>
				<ActionButton nctid={trial?.objectID} />

				<div className={styles['footer-tags']}>
					{tags.map((tag, i) => (
						<ToolTip
							key={i}
							type='tag'
							icon={tag.icon as [IconPrefix, IconName]}
							title={tag.label}
							content={tag.description}
						/>
					))}
				</div>
				<Link href={`/trial/${trial?.objectID}`}>
					<div className={styles.btn}>more info...</div>
				</Link>
			</div>
		</div>
	);
}
